import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Container = styled.div``;

export const Wrapper = styled.div<{ wrap: string }>`
  display: flex;
  padding: 10px 15px;
  gap: 8px;
  ${mediaQuery('phone')} {
    ${(props) => props.wrap === 'true' && 'flex-wrap: wrap;'}
  }
`;

export const Label = styled.h2<{ wrap: string }>`
  font-weight: 700;
  flex-basis: 50%;
  font-size: 16px;
  line-height: 22px;
  ${mediaQuery('phone')} {
    ${(props) => props.wrap === 'true' && 'flex-basis: 100%'}
  }
`;

export const Value = styled.div<{ wrap?: string }>`
  flex: 1;
  display: inline-flex;
  align-items: center;
  white-space: pre-wrap;
  height: 100%;
  line-height: 100%;
  font-size: 16px;
  line-height: 22px;
  ${mediaQuery('phone')} {
    ${(props) =>
      props.wrap === 'true' &&
      `
    flex-basis: 100%;
    text-align: left;
    `}
  }
`;

export const LabelIconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-top: 2px;
  margin-right: 10px;
  width: 24px;
  max-height: 24px;
  color: ${(props) => props.theme.color.blue.default};
`;

export const WhatsAppContainer = styled.div`
  margin-bottom: '0px';
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  margin-top: 20px;
`;
